import { Address } from '@models/address';
import { BaseTransactionAddress } from '@models/mortgages/mortgage-base';

export enum SubmitStatus {
	SELECT_FUNDING_DETAILS = 'SELECT_FUNDING_DETAILS',
	REQUEST_FOR_FUNDS = 'REQUEST_FOR_FUNDS',
	FINAL_REPORT = 'FINAL_REPORT',
	COMPLETED = 'COMPLETED',
	CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
	CANCELLED = 'CANCELLED',
}

/**
 * Converts a BaseTransactionAddress object to an Address object.
 * @param address - The BaseTransactionAddress to be converted.
 * @returns The converted Address object.
 */
function convertAddress(address: BaseTransactionAddress): Address {
	return {
		city: address.city,
		country: address.country,
		postcode: address.postalCode,
		province: address.province,
		street: address.streetAddress1,
	};
}

export { convertAddress };
